import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio1To324(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMediaObjectRatio1To324"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.5 5.5v13a1 1 0 1 1-2 0v-13a1 1 0 0 1 2 0M2 5.5a2.5 2.5 0 0 1 5 0v13a2.5 2.5 0 0 1-5 0zm8.041.25a.75.75 0 0 1 .75-.75H21.23a.75.75 0 0 1 0 1.5H10.791a.75.75 0 0 1-.75-.75m0 6a.75.75 0 0 1 .75-.75H21.23a.75.75 0 0 1 0 1.5H10.791a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h5.974a.75.75 0 0 0 0-1.5zm-.75 6.75a.75.75 0 0 1 .75-.75h5.974a.75.75 0 0 1 0 1.5h-5.974a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio1To324);
